import { render, staticRenderFns } from "./SeckillDetail.vue?vue&type=template&id=2a1cba69&scoped=true"
import script from "./SeckillDetail.vue?vue&type=script&lang=js"
export * from "./SeckillDetail.vue?vue&type=script&lang=js"
import style0 from "./SeckillDetail.vue?vue&type=style&index=0&id=2a1cba69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1cba69",
  null
  
)

export default component.exports